export default __webpack_public_path__ + "9726a5087996a73d219985ed056debd5.svg";